import styled, { css } from 'styled-components';

export const Container = styled.div`
  min-height: 100vh;
  width: 100%;
  background: var(--white-dark);
  display: flex;
  flex-direction: column;

  @media (max-width: 800px) {
    padding: 0;
  }
`;

export const Content = styled.div`
  height: 100%;
  width: 100%;
  padding: 40px 30%;

  [type='radio']:checked,
  [type='radio']:not(:checked) {
    display: none;
  }
  [type='radio']:checked + label,
  [type='radio']:not(:checked) + label {
    position: relative;
    padding-left: 48px;
    cursor: pointer;
    line-height: 34px;
    display: inline-block;
  }
  [type='radio']:checked + label:before,
  [type='radio']:not(:checked) + label:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 30px;
    height: 30px;
    border: 1px solid var(--gray-d);
    border-radius: 100%;
    background: var(--white);
  }
  [type='radio']:checked + label:after,
  [type='radio']:not(:checked) + label:after {
    content: '';
    width: 20px;
    height: 20px;
    background: var(--info);
    position: absolute;
    top: 5.8px;
    left: 5.8px;
    border-radius: 50%;
    -webkit-transition: all 0.4s ease;
    transition: all 0.4s ease;
  }
  [type='radio']:not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  [type='radio']:checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }

  @media (max-width: 800px) {
    padding: 32px 24px;
  }
`;

export const FiltersGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 40px;
`;

export const SwitchContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
  position: relative;
`;

export const SwitchLabel = styled.p`
  font-weight: 500;
  font-size: 16px;
  line-height: 21px;
`;

export const SwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--gray-c);
  transition: 0.4s;
  border-radius: 34px;

  :before {
    position: absolute;
    content: '';
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: 0.4s;
    transition: 0.4s;
    border-radius: 50%;
  }
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  border-radius: 34px;
`;

export const SwitchInputElement = styled.input`
  opacity: 0;
  width: 0;
  height: 0;
  position: absolute;
  right: 0;

  :disabled {
    + span,
    + span:before {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  :checked + span {
    background-color: var(--info);
  }

  :checked + span:before {
    transform: translateX(26px);
  }
`;
